<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: ['lineData', 'lineLabels'],
  mounted () {
    this.render()
  },
  watch: {
    lineData: function () {
      this.render()
    }
  },
  methods: {
    render: function () {
      this.renderChart({
        labels: this.lineLabels,
        datasets: [
          {
            label: this.$t('ANALYTICS.TOTAL_FORMS'),
            backgroundColor: '#20a8d8',
            data: this.lineData
          }
        ]
      }, {responsive: true, maintainAspectRatio: false})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/reports/LineChart.vue